import React from 'react';
import { Navigate } from 'react-router-dom';
import Header from "../../components/Header/Header";
import Login from "../../components/Login/Login";
import Footer from "../../components/Footer/Footer";
import { obterConta, obterToken } from '../../services/api';

export default function ClienteAuth() {
  const token = obterToken();
  const conta = obterConta();

  if (token && conta?.role === 'admin') {
    return <Navigate to="/admin/home" replace />;
  }

  if (token && conta?.role === 'cliente') {
    return <Navigate to="/cliente/home" replace />;
  }

  return (
    <>
      <Header />
      <Login permitirCadastro tituloLogin="Acesso do Cliente" />
      <Footer />
    </>
  );
}
